import { Box } from "@mui/material"
import { TextField } from "react-admin"

const IntroductionComponent = () => {
  return (
    <Box mt={2}>
      <TextField source="textModel.introduction" whiteSpace={'pre-line'} />
    </Box>
  )
}

export default IntroductionComponent